import { render, staticRenderFns } from "./SpecialZonesDropdown.vue?vue&type=template&id=2b88799c&scoped=true&"
import script from "./SpecialZonesDropdown.vue?vue&type=script&lang=js&"
export * from "./SpecialZonesDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SpecialZonesDropdown.vue?vue&type=style&index=0&id=2b88799c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b88799c",
  null
  
)

export default component.exports